module.exports = __webpack_public_path__ + "img/mail.2b0e5932.svg";